module.exports = __webpack_public_path__ + "static/media/last_page.51833618.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/last_page.svg
// module id = 1739
// module chunks = 0